module.exports = __webpack_public_path__ + "static/media/heroes.8a8f8fdf.png";